import { useState } from "react";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShareAlt, faThumbsUp as thumbsUp, faThumbsDown as thumbsDown } from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp, faThumbsDown, faCommentAlt } from "@fortawesome/free-regular-svg-icons";

import { AuthorInfo } from "./author-info";
import { useAuth } from "../../services/authentication/authentication.context";
import { ellispisis } from "../../helpers/utility-methods";
import { formatUrl } from "../../helpers/parse-url";
import { TagsContainer } from "../forms/tags-container";

export const DiscussionUnit = ({ post }) => {

    const [postOpen, setPostOpen] = useState(false);

    const toggleViewPost = () => setPostOpen((v) => !v);

    const { userData } = useAuth();

    return (
        <div className="post-item">
            <AuthorInfo
                post={post}
                userData={userData}
                postMenu={null}
            />
            <div className='post-title'>{post?.title}</div>
            <div
                className="post-content"
                dangerouslySetInnerHTML={{
                    __html: post?.content?.length < 250 || postOpen ?
                        post?.content :
                        ellispisis(post?.content, 250)
                }}
            />
            <div>
                {post?.media?.image &&
                    <div
                        className={classNames(
                            'post-image-box',
                            { 'viewed': postOpen }
                        )}
                    >
                        <img
                            src={formatUrl(post?.media?.image)}
                            className='post-image'
                            alt=''
                        />
                    </div>
                }
            </div>
            {(post?.content?.length >= 250 || post?.media?.image) &&
                <button
                    className="more"
                    onClick={() => toggleViewPost()}
                >
                    {postOpen ? 'See less' : 'See more...'}
                </button>
            }
            <TagsContainer tagsData={post?.tags} />
            <div className='reaction-box'>
                <button
                    className="reaction-buttons"
                >
                    <span className='react-cnt'>
                        {post?.likes?.length || ''}
                    </span>
                    <FontAwesomeIcon
                        icon={
                            post?.likes.includes(userData?._id) ?
                                thumbsUp : faThumbsUp
                        }
                    />
                </button>
                <button
                    className="reaction-buttons"
                >
                    <span className='react-cnt'>
                        {post?.unlikes?.length || ''}
                    </span>
                    <FontAwesomeIcon
                        icon={
                            post?.unlikes.includes(userData?._id) ?
                                thumbsDown : faThumbsDown
                        }

                    />
                </button>
                <button
                    className="reaction-buttons"
                >
                    <span className='react-cnt'>
                        {post?.replies?.length || ''}
                    </span>
                    <FontAwesomeIcon icon={faCommentAlt} />
                </button>
                <button className="reaction-buttons">
                    <FontAwesomeIcon icon={faShareAlt} />
                </button>
            </div>
        </div>
    )
}